import { constants } from '@app/constants';
import { EUAppConfig, CoreServicesInitOptions } from '@eucoms/common-components';

import { environment } from '@environments/environment';

export const appConfig: EUAppConfig = {
  common: {
    noReply: 'no-reply@exeloncorp.com',
    logoutUrl: '../pages/logout.aspx',
    reportOutageTitle: 'Report an Outage Online',
    registerNowUrl: '../Pages/UserRegistrationLanding.aspx',
  },
  BGE: {
    isUsePingMock: false,
    isUnderConstruction: false,
    contactNo: '1-877-778-2222',
    companyDescription: 'Baltimore Gas and Electric Company',
    infoMessages: [
      '<div class="header-text">If you smell natural gas, leave the area immediately </div> and call BGE at <span class="d-none d-xl-inline-block semi-bold-font">1-877-778-7798</span><span class="d-inline-block d-xl-none"><a class="link-text" href="tel:+1-877-778-7798">1-877-778-7798</a></span> or <span class="d-none d-xl-inline-block semi-bold-font">1-800-685-0123</span><span class="d-inline-block d-xl-none"><a class="link-text" href="tel:+1-800-685-0123">1-800-685-0123</a></span>. For downed power lines, stay away from the area and call BGE at <span class="d-none d-xl-inline-block semi-bold-font">1-877-778-2222</span><span class="d-inline-block d-xl-none"><a class="link-text" href="tel:+1-877-778-2222">1-877-778-2222</a></span> or <span class="d-none d-xl-inline-block semi-bold-font">1-800-685-0123</span><span class="d-inline-block d-xl-none"><a class="link-text" href="tel:+1-800-685-0123">1-800-685-0123</a></span>.',
    ],
    favIcon: 'assets/favicon/bge/favicon.ico',
    logoName: 'logo-bge.svg',
    footerMessage: 'Baltimore Gas and Electric Company, 2019. All Rights Reserved.',
    outagePollingInterval: 120000, /* Setting the polling time to 2 min for outage tracker */
    outageRestorationHours: 24,
    pageTitle: 'Outage Tracker | Baltimore Gas and Electric Company',
    minIdleTime: 60,
    maxIdleTime: 1200,
    showMedalliaOutageSurvey: true
  },
  PECO: {
    isUsePingMock: false,
    isUnderConstruction: false,
    contactNo: '1-800-841-4141',
    companyDescription: 'PECO - An Exelon Company',
    infoMessages: [
      'To report a gas emergency or a downed or sparking power line, please call 1-800-841-4141.',
    ],
    favIcon: 'assets/favicon/peco/favicon.ico',
    logoName: 'logo-peco.svg',
    footerMessage: 'PECO Energy Company, 2019. All Rights Reserved.',
    outagePollingInterval: 120000, /* Setting the polling time to 2 min for outage tracker */
    minIdleTime: 60,
    maxIdleTime: 1200,
    showMedalliaOutageSurvey: true
  },
  ComEd: {
    isUsePingMock: false,
    isUnderConstruction: false,
    contactNo: '1-800-334-7661',
    companyDescription: 'ComEd',
    infoMessages: [
      '<div class="header-text">If you smell natural gas, leave the area immediately </div> and call ComEd at <span class="d-none d-xl-inline-block semi-bold-font">1-800-334-7661</span><span class="d-inline-block d-xl-none"><a class="link-text" href="tel:+1-800-334-7661">1-800-334-7661</a></span> or <span class="d-none d-xl-inline-block semi-bold-font">1-800-334-7661</span><span class="d-inline-block d-xl-none"><a class="link-text" href="tel:+1-800-334-7661">1-800-334-7661</a></span>. For downed power lines, stay away from the area and call ComEd at <span class="d-none d-xl-inline-block semi-bold-font">1-800-334-7661</span><span class="d-inline-block d-xl-none"><a class="link-text" href="tel:+1-800-334-7661">1-800-334-7661</a></span> or <span class="d-none d-xl-inline-block semi-bold-font">1-800-334-7661</span><span class="d-inline-block d-xl-none"><a class="link-text" href="tel:+1-800-334-7661">1-800-334-7661</a></span>.',
    ],
    favIcon: 'assets/favicon/bge/favicon.ico',
    logoName: 'logo-bge.svg',
    footerMessage: 'Commonwealth Edison Company, 2024. All Rights Reserved.',
    outagePollingInterval: 120000, /* Setting the polling time to 2 min for outage tracker */
    outageRestorationHours: 24,
    pageTitle: 'Outage Tracker | ComEd - An Exelon Company',
    minIdleTime: 60,
    maxIdleTime: 1200,
    showMedalliaOutageSurvey: true
  },
  PEPCO: {
    isUsePingMock: false,
    isUnderConstruction: false,
    contactNo: '1-877-737-2662',
    companyDescription: 'Pepco - An Exelon Company',
    infoMessages: [
      'To report a downed or sparking power line, please call 1-877-737-2662.',
    ],
    favIcon: 'assets/favicon/pepco/favicon.ico',
    logoName: 'logo-pepco.svg',
    footerMessage: 'Potomac Electric Power Company, 2020. All Rights Reserved.',
    showRatingFeedback: false,
    showMedalliaOutageSurvey: true,
    outagePollingInterval: 120000,
    minIdleTime: 60,
    maxIdleTime: 1200
  },
  DPL: {
    isUsePingMock: false,
    isUnderConstruction: false,
    contactNo: '1-800-375-7117',
    companyDescription: 'Delmarva Power - An Exelon Company',
    infoMessages: [
      'If you smell natural gas, leave the area immediately and then call 302-454-0317.',
      'To report a downed or sparking power line, please call 1-800-375-7117.',
    ],
    favIcon: 'assets/favicon/dpl/favicon.ico',
    logoName: 'logo-delmarva.svg',
    footerMessage: 'Delmarva Power & Light Company, 2020. All Rights Reserved.',
    showRatingFeedback: false,
    showMedalliaOutageSurvey: true,
    outagePollingInterval: 120000,
    minIdleTime: 60,
    maxIdleTime: 1200
  },
  ACE: {
    isUsePingMock: false,
    isUnderConstruction: false,
    contactNo: '1-800-833-7476',
    companyDescription: 'Atlantic City Electric - An Exelon Company',
    infoMessages: [
      'To report a downed or sparking power line, please call 1-800-833-7476.',
    ],
    favIcon: 'assets/favicon/dpl/favicon.ico',
    logoName: 'logo-ace.svg',
    footerMessage: '© Atlantic City Electric Company, 2022. All Rights Reserved.',
    showRatingFeedback: false,
    showMedalliaOutageSurvey: true,
    outagePollingInterval: 120000,
    minIdleTime: 60,
    maxIdleTime: 1200
  }
};

export const initOptionsCommon = Object.assign(
  {},
  appConfig.common,
  (constants.CoreServicesInitOptions.additionalConfig as EUAppConfig).common
);

export const coreServicesInitOptions = getCoreServiceInitOptions();

function getCoreServiceInitOptions() {
  if (environment.devEnvironment) {
    const devCoreServicesInitOptions: CoreServicesInitOptions = Object.assign(
      {},
      constants.CoreServicesInitOptions,
      {
        additionalConfig: Object.assign(appConfig,
          {
            common: initOptionsCommon
          }
        )
      }
    );
    return devCoreServicesInitOptions;
  }
  return { additionalConfig: appConfig };
}
